export default function productGrid() {
  return {
    _id: false,
    type: 'droplet.productGrid',
    hideFilters: false,
    customCategories: [],
    customList: false,
    paginate: 24,
    sortKey: false,
    sort: 'newest',
    mediaQueries: [],
    pageCSS: '',
    placeholder: 'Search...',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    filterText: 'Filters',
    match: 'all',
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/product-grid/droplet.schema.js